import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { NewClusterStore, CreateClusterDto } from '../../../../../stores/configuration/machinery/clusters-store';
import { nameof } from '../../../../../utils/object';

interface NewClusterViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newCluster?: NewClusterStore;
}

// tslint:disable-next-line:no-empty-interface
interface NewClusterViewState {}

@connect(['newCluster', NewClusterStore])
class NewClusterView extends React.Component<NewClusterViewProps, NewClusterViewState> {
  private get newClusterStore() {
    return this.props.newCluster;
  }

  constructor(props: NewClusterViewProps) {
    super(props);
    this.newClusterStore.createNew({
      name: ''
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewClusterViewProps) {
    if (this.newClusterStore.state.result && this.newClusterStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.newClusterStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newClusterStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.newClusterStore.change({ ...this.newClusterStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newClusterStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Cluster')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newClusterStore.state.result && !this.newClusterStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newClusterStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newClusterStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    fluid
                    label={t('Cluster')}
                    placeholder={t('Name')}
                    value={this.newClusterStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateClusterDto>('name'), value)}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewClusterView);
